import { OrganizationServiceOrganizationGqlOutput } from 'zma-react-sdk/organization-service'
import { UserServiceTenantGqlOutput } from 'zma-react-sdk/user-service'
import { create } from 'zustand'

interface AppState {
  organization: OrganizationServiceOrganizationGqlOutput | null
  setOrganization: (
    organization: OrganizationServiceOrganizationGqlOutput | null
  ) => void
  tenant: UserServiceTenantGqlOutput | null
  setTenant: (tenant: UserServiceTenantGqlOutput | null) => void
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
}

export const useAppStore = create<AppState>()((set) => ({
  organization: null,
  setOrganization: (
    organization: OrganizationServiceOrganizationGqlOutput | null
  ) => set({ organization }),
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  tenant: null,
  setTenant: (tenant: UserServiceTenantGqlOutput | null) => set({ tenant }),
}))
